var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-list-group',[_c('donation-group'),_c('bank-account'),_c('safe-account'),_c('donate-date'),_c('notes-text'),_c('amount')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }